"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pluralizeYears = exports.pluralizeTours = exports.pluralizeTouristsAcc = exports.pluralizeTourists = exports.pluralizeReviews = exports.pluralizeOptions = exports.pluralizeNights = exports.pluralizeMinutesGen = exports.pluralizeLuggage = exports.pluralizeKids = exports.pluralizeHoursGen = exports.pluralizeHotels = exports.pluralizeFlights = exports.pluralizeDays = exports.pluralizeAdults = void 0;

var _stringUtils = require("./stringUtils");

var PLURAL = {
  YEARS: ['год', 'года', 'лет'],
  DAYS: ['день', 'дня', 'дней'],
  KIDS: ['ребёнок', 'ребёнка', 'детей'],
  ADULTS: ['взрослый', 'взрослых', 'взрослых'],
  NIGHTS: ['ночь', 'ночи', 'ночей'],
  TOURS: ['тур', 'тура', 'туров'],
  HOTELS: ['отель', 'отеля', 'отелей'],
  FLIGHTS: ['рейс', 'рейса', 'рейсов'],
  OPTIONS: ['вариант', 'варианта', 'вариантов'],
  REVIEWS: ['отзыв', 'отзыва', 'отзывов'],
  TOURISTS: ['турист', 'туриста', 'туристов'],
  TOURISTS_ACC: ['туриста', 'туристов', 'туристов'],
  HOURS_GEN: ['часе', 'часах', 'часах'],
  MINUTES_GEN: ['минуте', 'минутах', 'минутах'],
  LUGGAGE: ['место', 'места', 'мест']
};

var pluralizeYears = function pluralizeYears(value) {
  return (0, _stringUtils.pluralize)(value, PLURAL.YEARS);
};

exports.pluralizeYears = pluralizeYears;

var pluralizeDays = function pluralizeDays(value) {
  return (0, _stringUtils.pluralize)(value, PLURAL.DAYS);
};

exports.pluralizeDays = pluralizeDays;

var pluralizeKids = function pluralizeKids(value) {
  return (0, _stringUtils.pluralize)(value, PLURAL.KIDS);
};

exports.pluralizeKids = pluralizeKids;

var pluralizeAdults = function pluralizeAdults(value) {
  return (0, _stringUtils.pluralize)(value, PLURAL.ADULTS);
};

exports.pluralizeAdults = pluralizeAdults;

var pluralizeNights = function pluralizeNights(value) {
  return (0, _stringUtils.pluralize)(value, PLURAL.NIGHTS);
};

exports.pluralizeNights = pluralizeNights;

var pluralizeTours = function pluralizeTours(value) {
  return (0, _stringUtils.pluralize)(value, PLURAL.TOURS);
};

exports.pluralizeTours = pluralizeTours;

var pluralizeHotels = function pluralizeHotels(value) {
  return (0, _stringUtils.pluralize)(value, PLURAL.HOTELS);
};

exports.pluralizeHotels = pluralizeHotels;

var pluralizeFlights = function pluralizeFlights(value) {
  return (0, _stringUtils.pluralize)(value, PLURAL.FLIGHTS);
};

exports.pluralizeFlights = pluralizeFlights;

var pluralizeOptions = function pluralizeOptions(value) {
  return (0, _stringUtils.pluralize)(value, PLURAL.OPTIONS);
};

exports.pluralizeOptions = pluralizeOptions;

var pluralizeReviews = function pluralizeReviews(value) {
  return (0, _stringUtils.pluralize)(value, PLURAL.REVIEWS);
};

exports.pluralizeReviews = pluralizeReviews;

var pluralizeTourists = function pluralizeTourists(value) {
  return (0, _stringUtils.pluralize)(value, PLURAL.TOURISTS);
};

exports.pluralizeTourists = pluralizeTourists;

var pluralizeTouristsAcc = function pluralizeTouristsAcc(value) {
  return (0, _stringUtils.pluralize)(value, PLURAL.TOURISTS_ACC);
};

exports.pluralizeTouristsAcc = pluralizeTouristsAcc;

var pluralizeHoursGen = function pluralizeHoursGen(value) {
  return (0, _stringUtils.pluralize)(value, PLURAL.HOURS_GEN);
};

exports.pluralizeHoursGen = pluralizeHoursGen;

var pluralizeMinutesGen = function pluralizeMinutesGen(value) {
  return (0, _stringUtils.pluralize)(value, PLURAL.MINUTES_GEN);
};

exports.pluralizeMinutesGen = pluralizeMinutesGen;

var pluralizeLuggage = function pluralizeLuggage(value) {
  return (0, _stringUtils.pluralize)(value, PLURAL.LUGGAGE);
};

exports.pluralizeLuggage = pluralizeLuggage;